import React from 'react';
import { Palette } from 'lucide-react';

const themes = [
    { id: 'slate', name: 'Slate', description: 'Enterprise Neutral' },
    { id: 'indigo', name: 'Indigo', description: 'Modern SaaS' },
    { id: 'emerald', name: 'Emerald', description: 'Green Tech' },
    { id: 'sandstone', name: 'Sandstone', description: 'Warm Consultancy' },
    { id: 'cerulean', name: 'Cerulean', description: 'Calm Blue' },
    { id: 'charcoal', name: 'Charcoal', description: 'Dashboard/Dark-first' }
];

export const ThemeSwitcher: React.FC = () => {
    const [currentTheme, setCurrentTheme] = React.useState('slate');
    const [isOpen, setIsOpen] = React.useState(false);

    const changeTheme = (themeId: string) => {
        const html = document.documentElement;
        // Remove existing theme classes
        themes.forEach(theme => {
            html.classList.remove(`theme-${theme.id}`);
        });
        // Add new theme class
        html.classList.add(`theme-${themeId}`);
        setCurrentTheme(themeId);
        setIsOpen(false);
    };

    const currentThemeInfo = themes.find(t => t.id === currentTheme);

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[hsl(var(--button-secondary-bg))] text-[hsl(var(--button-secondary-fg))] border border-[hsl(var(--button-secondary-border))] hover:bg-[hsl(var(--button-secondary-hover-bg))] transition-colors"
                title={`Theme: ${currentThemeInfo?.name} - ${currentThemeInfo?.description}`}
            >
                <Palette className="h-4 w-4" />
            </button>

            {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-[hsl(var(--dropdown-bg))] border border-[hsl(var(--dropdown-border))] rounded-lg shadow-lg z-[300]">
                    <div className="p-2">
                        <div className="text-xs font-medium text-[hsl(var(--muted-foreground))] mb-2 px-2">
                            Choose Theme
                        </div>
                        {themes.map((theme) => (
                            <button
                                key={theme.id}
                                onClick={() => changeTheme(theme.id)}
                                className={`w-full text-left px-2 py-2 rounded-md text-sm transition-colors ${currentTheme === theme.id
                                    ? 'bg-primary text-primary-foreground'
                                    : 'hover:bg-muted'
                                    }`}
                            >
                                <div className="font-medium">{theme.name}</div>
                                <div className="text-xs opacity-75">{theme.description}</div>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
